import InfoBox from 'components/InfoBox';
import { Flex } from 'components/base/layout-components';
import { Footer } from './repositories-modal.components';
import {
  getFreeSlotsMessage,
  getSelectedReposMessage,
  getTotalSelectedRepositories,
  hasInvalidCMRepo
} from './repositories-modal.service';
import { LBButton } from '@linearb/buzz';
import InvalidRepoNameWarning from 'components/InvalidRepoNameWarnin';

const RepositoriesModalFooter = ({
  numOfFreeSlots,
  isOnboarding,
  selected,
  orgRepositories,
  maxRepos,
  saving,
  onSubmit,
  isTeamLicense,
  isConnectGitStreamFlow,
  onRefetch
}) => {
  const hasInvalidRepo = hasInvalidCMRepo(selected, orgRepositories);

  return (
    <Footer isOnboarding={isOnboarding} direction='column'>
      <InfoBox
        mt={null}
        mb='medium'
        direction='row'
        iconAlign='center'
        items='center'
      >
        {getSelectedReposMessage({ selected })}
        {getFreeSlotsMessage({
          numOfFreeSlots,
          isTeamLicense,
          maxRepos,
          isOnboarding,
          selected
        })}
      </InfoBox>
      {hasInvalidRepo && (
        <div style={{ marginBottom: '1rem' }}>
          <InvalidRepoNameWarning />
        </div>
      )}
      <Flex items='center' justify='end'>
        <LBButton
          data-cy='continue'
          disabled={getTotalSelectedRepositories(selected) === 0 || saving}
          onClick={() => (hasInvalidRepo ? onRefetch() : onSubmit())}
        >
          {hasInvalidRepo
            ? 'Try Again'
            : isConnectGitStreamFlow
            ? 'Finish'
            : 'Save Repositories'}
        </LBButton>
      </Flex>
    </Footer>
  );
};

export default RepositoriesModalFooter;
